/**=========================================================
 * Module: template.js
 * Template Controller
 =========================================================*/

App.controller('TemplateController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D) {
    "use strict";
     
    $scope.type = 'template';
    $scope.filter = $state.params.filter;
    
    $scope.data = [];
    
    $scope.page = {
            title: 'labels.TEMPLATE',
            subTitle: ''
        };
      
    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function(){  
      
        if($rootScope.user.id){
            $scope.initialized = true;
            
            $scope.form = {
                title: '',
                status: '',
                type: 'template',
                fields: [
                    {
                        available: true,
                        type: 'static',
                        name: 'template'
                    },{
                        available: true,
                        type: 'static',
                        name: 'language'
                    },{
                        available: true,
                        type: 'text',
                        name: 'subject'
                    },{
                        available: true,
                        type: 'textarea',
                        name: 'text'
                    },{
                        available: true,
                        type: 'editor',
                        name: 'html'
                    },{
                        available: true,
                        type: 'text',
                        name: 'action'
                    },{
                        available: true,
                        type: 'text',
                        name: 'link'
                    },{
                        available: true,
                        type: 'separator'
                    },{
                        available: true,
                        type: 'submit',
                        name: 'empty',
                        value: 'fields.SUBMIT'
                    }
                ],
                submit: function(){
                    $scope.form.status = 'submitting';
                    D.save($scope.type, $scope.form.model).then(
                        function(response){
                            $scope.form.status = 'submitted';
                        }
                        
                    ).catch(function(response){
                            $scope.form.status = 'error';
                        });
                }
            };
            

            D.load($scope.type, $scope.filter).then(
                        function(response){
                            $scope.form.model = response;
                        }
                        
                    ).catch(function(error){
                            $scope.error = error;
                        });
            
        } else {
            if(!$scope.watchActivated){
                $scope.watchActivated = true;
                $rootScope.$watch('user.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });
            }
        }
    }
    
    $scope.init();
      
}]);